/* global $ */
const scaleSplashScreenToPage = function () {
  let homepagevideo = document.querySelector('#homepage-video');
  let fullHeight = $(window).innerHeight();
  let fullWidth = $(window).innerWidth();
  let newHeight = fullHeight;
  let newWidth = ((newHeight / 9) * 16);

  if (newWidth < fullWidth) {
    newWidth = fullWidth;
    newHeight = ((newWidth / 16) * 9);
  }
  homepagevideo.style.width = `${newWidth}px`;
  homepagevideo.style.height = `${newHeight}px`;
  document.querySelector('.homepage-splash').style.height = `${fullHeight}px`;
};

export default function onYoutubePlayerReady (event) {
  $(window).on('resize', () => {
    scaleSplashScreenToPage();
  });
  event.target.setVolume(0);
  scaleSplashScreenToPage();
  if (window.scrollY === 0) {
    event.target.playVideo();
  }
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/youtube/onYoutubePlayerReady.js